





















































































import Vue from "vue";
import Component from "vue-class-component";
import { BlogManagerArticleService as articleApi } from "@/common/api/services/BlogManagerArticleService";
import { MemberManagerService as memberApi } from "@/common/api/services/MemberManagerService";
import { MeService as meApi } from "@/common/api/services/MeService";
import { formatImageUrl } from "@/common/utils";
import qSlider from "@/common/qSlide.vue";
import { Watch } from "vue-property-decorator";
import qNotify from "@/common/qNotify";
import _isEmpty from "lodash/isEmpty";

@Component({
  name: "BlogDetail",
  components: {
    qSlider,
  },
})
export default class BlogDetail extends Vue {
  params: any = {
    id: null,
    groupId: null,
  };

  article: any = {
    title: "",
    article_likes: {
      like_count: 0,
    },
    images: [],
  };

  nextInfo: any = {
    next: {},
    prev: {},
    isLike: 0,
  };

  mounted() {
    // this.reload();
  }

  reload() {
    this.params = this.$router.currentRoute.params;
    this.getDetail();
    this.getNextArticle();
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newValue: any) {
    if (newValue.name == "group.blog.detail") {
      this.reload();
    }
  }

  get isLike() {
    return this.nextInfo.isLike ? "on" : "";
  }

  async getDetail() {
    try {
      const result = await memberApi.memberArticleShow(this.params);

      this.article.images = [];
      this.article = result.data.article;
      this.$nextTick(() => {
        (this.$refs.qSlider as qSlider).init();
      });
    } catch (error) {
      if (error.status === 404) {
        return this.$router.push({
          name: "group.notFound",
          params: { groupId: this.params.id },
        });
      } else {
        qNotify.error({
          text: error.body.message,
        });
      }
    }
  }

  async getNextArticle() {
    const result = await articleApi.userArticleNext(this.params);

    this.nextInfo = result.data;
  }

  getUrlImage(image) {
    return formatImageUrl(image.name, "1600x960", "contain");
  }

  async like() {
    try {
      await meApi.meLike(this.params);
      this.nextInfo.isLike = this.nextInfo.isLike ? 0 : 1;
      this.article.article_likes.like_count += this.nextInfo.isLike ? 1 : -1;
    } catch (error) {
      qNotify.error({
        text: error.body.message,
      });
    }
  }

  public isEmpty(object) {
    return _isEmpty(object);
  }
}
